module.exports = __webpack_public_path__ + "img/edit-green.27ba0c8d.svg";